// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/background/leaf.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centered-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .centered-popup-content {
    background: #fff;
     background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
     background-position: left ;
     background-repeat: no-repeat;
     background-size: contain;
    border-radius: 8px;
    width: 100%;
    max-width: 500px;
    padding: 20px;
    min-height: 300px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    position: relative;
    opacity: 0;
    transform: translateY(500px); /* Initial position for animation */
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  }
  
  .centered-popup-content.open {
    opacity: 1;
    transform: translateY(0); /* Final position */
  }
  
  .centered-popup-content.close {
    opacity: 0;
    transform: translateY(500px); /* Move to the bottom before disappearing */
  }
  
  .centered-popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .centered-popup-header h2 {
    margin: 0;
  }
  
  .centered-popup-close {
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }
  
  .centered-popup-body {
    margin-top: 10px;
  }

  .popupCloaseBtn{
    width: 100%;
    height: 2px;
    position: relative;
    z-index: 10;
  }
  .popupCloaseBtn > div{
    position: absolute;
    right: 0px;
    top:-10px;
    font-size: 28px;
    cursor: pointer;
    color: var(--Lime_Green);
  }
  
  .popupCloaseBtn > div:hover{
    color: #64a250;
  }
  `, "",{"version":3,"sources":["webpack://./src/commanComponents/Modals/CenteredPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;KACf,yDAAyD;KACzD,0BAA0B;KAC1B,4BAA4B;KAC5B,wBAAwB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,wCAAwC;IACxC,kBAAkB;IAClB,UAAU;IACV,4BAA4B,EAAE,mCAAmC;IACjE,gEAAgE;EAClE;;EAEA;IACE,UAAU;IACV,wBAAwB,EAAE,mBAAmB;EAC/C;;EAEA;IACE,UAAU;IACV,4BAA4B,EAAE,2CAA2C;EAC3E;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".centered-popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .centered-popup-content {\n    background: #fff;\n     background-image: url(\"../../assets/background/leaf.svg\");\n     background-position: left ;\n     background-repeat: no-repeat;\n     background-size: contain;\n    border-radius: 8px;\n    width: 100%;\n    max-width: 500px;\n    padding: 20px;\n    min-height: 300px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    position: relative;\n    opacity: 0;\n    transform: translateY(500px); /* Initial position for animation */\n    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;\n  }\n  \n  .centered-popup-content.open {\n    opacity: 1;\n    transform: translateY(0); /* Final position */\n  }\n  \n  .centered-popup-content.close {\n    opacity: 0;\n    transform: translateY(500px); /* Move to the bottom before disappearing */\n  }\n  \n  .centered-popup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .centered-popup-header h2 {\n    margin: 0;\n  }\n  \n  .centered-popup-close {\n    background: transparent;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n  }\n  \n  .centered-popup-body {\n    margin-top: 10px;\n  }\n\n  .popupCloaseBtn{\n    width: 100%;\n    height: 2px;\n    position: relative;\n    z-index: 10;\n  }\n  .popupCloaseBtn > div{\n    position: absolute;\n    right: 0px;\n    top:-10px;\n    font-size: 28px;\n    cursor: pointer;\n    color: var(--Lime_Green);\n  }\n  \n  .popupCloaseBtn > div:hover{\n    color: #64a250;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
